import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

var w: any = window;
var unityInstance = w.unityInstance;

interface Props { }
export const UnityView: React.FC<Props> = () =>
{
    useEffect(() =>
    {
        w.createUnityInstance(document.querySelector("#unity-canvas"), {
            dataUrl: "game/Build/web.data",
            frameworkUrl: "game/Build/web.framework.js",
            codeUrl: "game/Build/web.wasm",
            streamingAssetsUrl: "game/StreamingAssets",
            companyName: "TwistedTamarin",
            productName: "Spectry",
            productVersion: "1.0"
        })
            .then((instance) =>
            {
                w.unityInstance = instance;
                unityInstance = w.unityInstance;
            })
            .catch((message) => { console.warn(message); });
    }, []);

    const onFocus = () =>
    {
        SendCommand("FOCUS", "NULL");
    };
    const onBlur = () =>
    {
        SendCommand("BLUR", "NULL");
    }
    return (<canvas id="unity-canvas" onMouseEnter={onFocus} onMouseLeave={onBlur}></canvas>);
};

export const SendCommand = (command: string, data: any) =>
{
    const cmd = { command: command, code: data };
    unityInstance?.SendMessage('LuaWebHelper', 'EventHandler', JSON.stringify(cmd));
};

export { unityInstance };
